import api from './api';

const supplierMasterService = {
  // Get all suppliers
  getAllSuppliers: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.supplierType) queryParams.append('supplierType', params.supplierType);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/supplier-master${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching suppliers:', error);
      throw error;
    }
  },

  // Get supplier by ID
  getSupplierById: async (id) => {
    try {
      const response = await api.get(`/supplier-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier:', error);
      throw error;
    }
  },

  // Get next supplier code
  getNextSupplierCode: async () => {
    try {
      const response = await api.get('/supplier-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next supplier code:', error);
      throw error;
    }
  },

  // Create supplier
  createSupplier: async (supplierData) => {
    try {
      const response = await api.post('/supplier-master', supplierData);
      return response.data;
    } catch (error) {
      console.error('Error creating supplier:', error);
      throw error;
    }
  },

  // Update supplier
  updateSupplier: async (id, supplierData) => {
    try {
      const response = await api.put(`/supplier-master/${id}`, supplierData);
      return response.data;
    } catch (error) {
      console.error('Error updating supplier:', error);
      throw error;
    }
  },

  // Delete supplier
  deleteSupplier: async (id) => {
    try {
      const response = await api.delete(`/supplier-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting supplier:', error);
      throw error;
    }
  },

  // Get supplier statistics
  getSupplierStats: async () => {
    try {
      const response = await api.get('/supplier-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier statistics:', error);
      throw error;
    }
  }
};

export default supplierMasterService;

